import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';

import LogoGethex from '../assets/img/gethex-peru-nuevo.png';
import './Layout.css';

import MainPage from './MainPage';
import Sidebar from './Sidebar';
export default function Layout(){

    const [isToggled, setToggled] = useState(true);

    const handleToggle =  () => {
       setToggled(!isToggled);
    };

    // console.log("Hola desde Layout");

    return (
        <>
            <header>
                <nav className={"navbar navbar-fixed-top navbar-expand-lg bg-body-tertiary text-white showWidth"+isToggled}>
                    <div className="container-fluid">
                        <div className="navbar-brand">
                            <button type="button" className="btn-toggle-fullwidth" onClick={handleToggle}>
                                <FontAwesomeIcon icon={icon({name: 'bars'})} />
                            </button>
                            <a className="navbar-brand" href="/">
                                <img className="img-responsive logo" src={LogoGethex} alt="Logo Gethex" />
                            </a>
                        </div>
                        
                        {/* <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon"></span>
                        </button>
                        <div className="collapse navbar-collapse" id="navbarSupportedContent">
                            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                                <li className="nav-item">
                                <a className="nav-link active" aria-current="page" href="#">Home</a>
                                </li>
                                <li className="nav-item">
                                <a className="nav-link" href="#">Link</a>
                                </li>
                                <li className="nav-item dropdown">
                                <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    Dropdown
                                </a>
                                <ul className="dropdown-menu">
                                    <li><a className="dropdown-item" href="#">Action</a></li>
                                    <li><a className="dropdown-item" href="#">Another action</a></li>
                                    <li><hr className="dropdown-divider" /></li>
                                    <li><a className="dropdown-item" href="#">Something else here</a></li>
                                </ul>
                                </li>
                                
                            </ul>
                            <form className="d-flex" role="search">
                                <input className="form-control me-2" type="search" placeholder="Search" aria-label="Search" />
                                <button className="btn btn-outline-success" type="submit">Search</button>
                            </form>
                        </div> */}
                        <div className="d-flex">
                            {/* <form className="d-flex" role="search">
                                <input className="form-control me-2" type="search" placeholder="Buscar" aria-label="Search" />
                                <button className="btn btn-outline-danger" type="submit">
                                <FontAwesomeIcon icon={icon({name: 'search'})} />
                                </button>
                            </form> */}
                            <div className="item-nav-left">
                                <FontAwesomeIcon icon={icon({name: 'bell'})} />
                                <span className="notification-dot"></span>
                            </div>
                        </div>
                        
                    </div>
                </nav>
            </header>
            <Sidebar state={isToggled}></Sidebar>
            <MainPage state={isToggled}></MainPage>
        </>
  
    );
}